import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import LoginAPI from '../services/api';
import { actions } from '.';
import { HTTPS_CODE } from 'common/config/constant';
import toast from 'react-hot-toast';

function* handleLoginSaga(
  action: PayloadAction<{ username: string; password: string }>
) {
  try {
    const response = yield call(() => LoginAPI.handleLogin(action.payload));
    yield put(actions.loginSuccess({ token: response.data.token }));
  } catch (error: any) {
    yield put(actions.loginFailure());
  }
}

function* fetchInfoProfile(action: ReturnType<typeof actions.fetchInfoProfile>) {
  try {
    const { method, data } = action.payload;
    const res = yield call(LoginAPI.fetchInfoProfile, method, method !== 'GET' ? data : undefined);

    if (method !== "GET" && res.code === HTTPS_CODE.success) {
      toast.success(res.message)
    }
    if (res.code !== HTTPS_CODE.success) {
      return toast.error(res.message)
    }
    yield put(actions.fetchInfoProfileSuccess(res.data));
  } catch (error) {
  }
}

export function* loginSaga() {
  yield takeLatest(actions.handleLogin.type, handleLoginSaga);
  yield takeLatest(actions.fetchInfoProfile.type, fetchInfoProfile);
}

